module.exports = __webpack_public_path__ + "static/media/CenterAlignBlue.9b811778.svg";